import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from '../axios';

const fetchData = () => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    axios
      .get(`https://www.hat.sofhare.com/counter/proves/`)
      .then((res) => {
        const filtelongeur = res.data.find(item => item.type === 'TOTCPT');
        const longeur = filtelongeur ? filtelongeur.Tot_geog : 0;
        const filtercpt = res.data.find(item => item.type === 'CPT');
        const lencpt = filtercpt ? filtercpt.Tot_geog : 0;
        const filtercptu = res.data.find(item => item.type === 'CPTU');
        const lencptu = filtercptu ? filtercptu.Tot_geog : 0;
        const filtercpte = res.data.find(item => item.type === 'CPTE');
        const lencpte = filtercpte ? filtercpte.Tot_geog : 0;
        const filterdmt = res.data.find(item => item.type === 'DMT');
        const lendmt = filterdmt ? filterdmt.Tot_geog : 0;
        const filtersdmt = res.data.find(item => item.type === 'SDMT');
        const lensdmt = filtersdmt ? filtersdmt.Tot_geog : 0;
        const filtersondaggio = res.data.find(item => item.type === 'SONDAGGIO');
        const lensondaggio = filtersondaggio ? filtersondaggio.Tot_geog : 0;
        resolve({
          lencpt,
          lencptu,
          lencpte,
          lendmt,
          lensdmt,
          lensondaggio
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const Graph = () => {
  const [series, setSeries] = useState([0, 0, 0]);

  const [options] = useState({
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px',
        fontFamily: 'roboto',
        fontWeight: 800,
        colors: ['#CC929292'],
      },
      background: {
        enabled: true,
        foreColor: 'black',
        padding: 4,
        borderRadius: 2,
        borderWidth: 1,
        borderColor: '#E9A628',
        opacity: 0.9,
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: '#000',
          opacity: 0.45,
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            value: {
              show: true,
              fontSize: '40px',
              fontFamily: 'roboto',
              color: '#E9A628',
              offsetY: 20,
              formatter: function (val) {
                return val;
              },
            },
            total: {
              show: true,
              label: 'Totale',
              color: '#E9A628',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
              },
            },
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      followCursor: true,
      intersect: false,
      style: {
        fontSize: '10px',
        fontFamily: 'roboto',
      },
    },
    labels: ['CPT', 'CPTU', 'CPTE', 'DMT', 'SDMT', 'SOND.'],
    colors: ['#eb0024', '#0079ad', '#fccc0c', '#0474a4', '#ec1c24', '#dedddc'],
    chart: {
      foreColor: '#E9A628',
    },
    stroke: {
      colors: ['black'],
    },
    legend: {
      show: true,
      position: 'top',
      fontSize: '12px',
      fontFamily: 'roboto',
      fontWeight: 400,
      foreColor: '#E9A628',
    },
    responsive: [
      {
        breakpoint: 550,
        options: {
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '2px',
            },
          },
          tooltip: {
            style: {
              fontSize: '2px',
            },
          },
          chart: {
            width: '100%',
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  });

  useEffect(() => {
    let isMounted = true;

    const getData = async () => {
      try {
        const res = await fetchData();
        if (isMounted) {
          setSeries([res.lencpt, res.lencptu, res.lencpte, res.lendmt, res.lensdmt, res.lensondaggio]);
        }
      } catch (err) {
        if (isMounted) {
          setSeries([0, 0, 0]);
        }
        console.error('Error fetching data:', err);
      }
    };

    getData();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <ReactApexChart options={options} series={series} type="donut" />
  );
};









